import { render, staticRenderFns } from "./Copy.vue?vue&type=template&id=18a773f2&scoped=true&"
import script from "./Copy.vue?vue&type=script&lang=ts&"
export * from "./Copy.vue?vue&type=script&lang=ts&"
import style0 from "./Copy.vue?vue&type=style&index=0&id=18a773f2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a773f2",
  null
  
)

export default component.exports